const oc_art = [,
    {
        oc_name: "POMO !!",
        link: 'https://baobears.com/character/BAO-159/gallery',
        img: process.env.PUBLIC_URL+ './images/oc-art/pomo-prompt-1.jpeg',
        artist: "me :)",
        artist_link: 'marketchipping.xyz',
    },
    {
        oc_name: "POMO !!",
        link: 'https://baobears.com/character/BAO-159/gallery',
        img: process.env.PUBLIC_URL+ './images/oc-art/pomo-prompt-2.jpeg',
        artist: "me :)",
        artist_link: 'marketchipping.xyz',
    },
    {
        oc_name: "Fresh-baked Bread",
        link: 'https://toyhou.se/21877830.bread-cat',
        img: process.env.PUBLIC_URL+ './images/oc-art/breadcat-commission-2.jpg',
        artist: "magaridilatte",
        artist_link: 'https://x.com/magaridilatte',
    },
    {
        oc_name: "Fresh-baked Bread",
        link: 'https://toyhou.se/21877830.bread-cat',
        img: process.env.PUBLIC_URL+ './images/oc-art/breadcat-commission.jpg',
        artist: "milquebread",
        artist_link: 'https://ko-fi.com/milquebread/',
    },
    {
        oc_name: "Nona",
        link: 'https://toyhou.se/8864283.nona-',
        img: process.env.PUBLIC_URL+ './images/oc-art/nona-1.jpg',
        artist: "hachibani",
        artist_link: 'https://hachibani.tumblr.com/',
    },
]
export default oc_art;